import { render, staticRenderFns } from "./OrderableCartItemSectionExtras.vue?vue&type=template&id=63230ec7&"
import script from "./OrderableCartItemSectionExtras.vue?vue&type=script&lang=ts&"
export * from "./OrderableCartItemSectionExtras.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports